import { linkToClassPage } from "../../../links";

export function linkToClassAssignmentsPage(classId?: string) {
  return `${linkToClassPage(classId)}/assignments`;
}
